import { IRequestSender } from '@studyportals/mb-platform-http-requests';
import { SuperAgentRequest, Response } from 'superagent';
import { PlatformIntegration } from '../../platform/platform-integration';

export class RequestSenderDecoratorUiLoader implements IRequestSender {
	private readonly target: IRequestSender;

	public constructor(target: IRequestSender) {
		this.target = target;
	}

	public async send(request: SuperAgentRequest): Promise<Response> {
		const loader = PlatformIntegration.instance.ui.loaderShow();

		try {
			return await this.target.send(request);
		} finally {
			loader.dispose();
		}
	}

	public async sendAndExtractBody<T>(request: SuperAgentRequest): Promise<T> {
		const loader = PlatformIntegration.instance.ui.loaderShow();

		try {
			return await this.target.sendAndExtractBody<T>(request);
		} finally {
			loader.dispose();
		}
	}
}
